class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.initializeCitySelect();
  }
   initializeCitySelect() {
  const citySelect = this.querySelector('.citieslist');
  const checkoutBtn = this.querySelector('.cart__checkout-button');

  console.log('initializeCitySelect called, CITIES_LIST length:', (window.CITIES_LIST || []).length);

  if (!citySelect || !checkoutBtn) {
    console.log('city select or checkout btn missing, aborting');
    return;
  }

  if (citySelect.options.length === 0) {
    const citiesList = window.CITIES_LIST || [];
    let cityOptions = `<option value="" disabled selected>Select City</option>`;
    citiesList.forEach((city) => {
      cityOptions += `<option value="${city}">${city}</option>`;
    });
    citySelect.innerHTML = cityOptions;
    console.log('populated options, new count:', citySelect.options.length);
  }

  checkoutBtn.disabled = !citySelect.value;

  const newCitySelect = citySelect.cloneNode(true);
  citySelect.replaceWith(newCitySelect);
  const newCheckoutBtn = checkoutBtn.cloneNode(true);
  checkoutBtn.replaceWith(newCheckoutBtn);

  newCitySelect.addEventListener('change', () => {
    newCheckoutBtn.disabled = !newCitySelect.value;
  });

  newCheckoutBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (newCitySelect.value) {
      window.location = `/checkout?checkout[shipping_address][city]=${encodeURIComponent(newCitySelect.value)}`;
    }
  });
}

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
    this.initializeCitySelect();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
